import { render } from "./gallerySection.vue?vue&type=template&id=011890aa"
import script from "./gallerySection.vue?vue&type=script&lang=js"
export * from "./gallerySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__